import { Linkedin, Youtube } from "lucide-react";
import { XIcon } from "@/components/site/XIcon";

export const socialLinks = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/deepchealth", icon: Linkedin },
  { label: "X", href: "https://x.com/deepchealth", icon: XIcon },
  { label: "YouTube", href: "https://www.youtube.com/channel/UCJelTnuYEARgt8A-adxs6LQ/videos", icon: Youtube },
];

export const bookMeetingUrl = "/contact?intent=meeting";
